export function LiveBadge() {
  return (
    <span className="inline-flex items-center justify-center px-1.5 bg-[#FF0000] rounded-[3px] font-lexend text-[12px] font-normal tracking-[-0.27px] capitalize text-white text-[10px]">
      Live
    </span>
  );
}
